package br.com.texeratx.boardgametimeapp.ui.screens.players

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.ui.components.PlayerAvatar

@Composable
fun PlayerAvatarMini(
    imageUrl: String?,
    name: String
) {
    if (!imageUrl.isNullOrBlank()) {
        PlayerAvatar(
            imageUrl = imageUrl,
            contentDescription = name,
            modifier = Modifier
                .size(28.dp)
                .clip(CircleShape)
        )
    } else {
        Box(
            modifier = Modifier
                .size(28.dp)
                .clip(CircleShape)
                .background(MaterialTheme.colorScheme.primaryContainer),
            contentAlignment = Alignment.Center
        ) {
            Text(
                name.first().uppercase(),
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.Bold
            )
        }
    }
}
